import httpClient from './httpClient';
const prefix = 'placetype';

export default {
  async getAll() {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getAll`);
    return data;
  },
  async getById(id) {
    const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getById/${id}`);
    return data;
  },
  async create(body) {
    const response = await httpClient({ requiresAuth: true }).post(`${prefix}/create`, body);
    return response;
  },
  async update(body, id) {
    const response = await httpClient({ requiresAuth: true }).put(`${prefix}/update/${id}`, body);
    return response;
  },
  async delete(id) {
    const response = await httpClient({ requiresAuth: true }).delete(`${prefix}/delete/${id}`);
    return response;
  }
}